import { useEffect } from "react";
import { axiosClient } from "@/lib/axiosClient";

const GlobalLogoutHandler = () => {
    useEffect(() => {
        const interceptor = axiosClient.interceptors.response.use(
            response => response,
            error => {
                const status = error.response?.status;
                const config = error.config;

                // Jika 401 dan bukan dari login endpoint
                if (status === 401 && config && !config.url?.includes("/login")) {
                    // Hapus token dan redirect manual
                    sessionStorage.removeItem("access_token");
                    localStorage.removeItem("access_token");
                    window.location.href = "/login";
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosClient.interceptors.response.eject(interceptor);
        };
    }, []);

    return null;
};

export default GlobalLogoutHandler;
